import { keys, mapValues, forEach, set } from 'lodash';

import { COLLECTION_ITEM_TYPES, COLLECTION_STORY_CARDS_TARGETING } from 'constants/collection';
import actions from 'state/constants';
import initialState from 'state/initialState';

const setCatalogParentCollection = (state, action) => {
  const { handle, ...otherData } = action.payload;

  // 1 - Crunch Storycards
  const storyCards = {};

  // move data from within the nested story card to the story card map
  forEach(action.payload.parentCollectionItems, item => {
    const { type, id, data } = item;

    if (type === COLLECTION_ITEM_TYPES.STORY_CARD) {
      set(storyCards, [id], data);
    }
  });

  forEach(action.payload.storyCardPlacements, item => {
    const { id, data } = item?.storyCard;

    set(storyCards, [id], { targeting: item?.targeting, ...data });
  });

  forEach(action.payload.experimentPageSections, section => {
    if (section?.content?._contentType === 'storyCardPlacement') {
      const { id, data } = section?.content?.storyCard;

      set(storyCards, [id], {
        targeting: COLLECTION_STORY_CARDS_TARGETING.DYNAMIC_YIELD,
        ...data,
      });
    }
  });

  return {
    ...state,
    parentCollections: {
      ...state.parentCollections,
      [handle]: {
        ...(state.parentCollections[handle] || {}),
        data: {
          handle,
          ...otherData,
        },
      },
    },
    storyCards,
  };
};

const fetchCatalogMasterProductRequest = (state, action) => {
  const { handle } = action.payload;

  return {
    ...state,
    masterProducts: {
      ...state.masterProducts,
      [handle]: {
        ...(state.masterProducts[handle] || {}),
        isLoading: true,
      },
    },
  };
};

const fetchCatalogMasterProductSuccess = (state, action) => {
  const { handle, products, ...otherData } = action.payload;

  const mungedProducts = mapValues(products, product => ({ data: product }));

  return {
    ...state,
    masterProducts: {
      ...state.masterProducts,
      [handle]: {
        ...(state.masterProducts[handle] || {}),
        isLoading: false,
        data: {
          handle,
          ...otherData,
          colorways: keys(mungedProducts),
        },
      },
    },
    colorways: {
      ...state.colorways,
      ...mungedProducts,
    },
  };
};

const fetchCatalogMasterProductFailure = (state, action) => {
  const { handle } = action.payload;

  return {
    ...state,
    masterProducts: {
      ...state.masterProducts,
      [handle]: {
        ...(state.masterProducts[handle] || {}),
        isLoading: false,
      },
    },
  };
};

const reducer = (state = initialState.catalog, action) => {
  switch (action.type) {
    case actions.SET_CATALOG_PARENT_COLLECTION:
      return setCatalogParentCollection(state, action);
    case actions.FETCH_CATALOG_MASTER_PRODUCT_REQUEST:
      return fetchCatalogMasterProductRequest(state, action);
    case actions.FETCH_CATALOG_MASTER_PRODUCT_SUCCESS:
      return fetchCatalogMasterProductSuccess(state, action);
    case actions.FETCH_CATALOG_MASTER_PRODUCT_FAILURE:
      return fetchCatalogMasterProductFailure(state, action);
    default:
      return state;
  }
};

export default reducer;
